import { combineReducers } from 'redux'

import auth from '@/containers/Login/AuthSlice'
import pageConfiguration from '@/store/PageConfiguration/PageConfigurationSlice'
import usersManagement from '@/containers/UsersManagement/UsersManagementSlice'
import servicesStatus from '@/containers/ServicesStatus/ServicesStatusSlice'
import carbonOffsets from '@/containers/CarbonOffsetManagement/CarbonOffsetsSlice'
import officesManagement from '@/containers/OfficesManagement/OfficesManagementSlice'
import teamsManagement from '@/containers/TeamsManagement/TeamsManagementSlice'
import assistanceProducts from '@/containers/AssistanceProductsManagement/AssistanceSlice'
import monConseillerPersoProducts from '@/containers/MonConseillerPersoProductsManagement/MonConseillerPersoSlice'
import dashboard from '@/containers/DashboardPage/DashboardSlice'
import subscriptionForm from '@/containers/SubscriptionFormPage/SubscriptionFormSlice'
import subscriptionFormConfiguration from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import formV2 from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import clientCallbacks from '@/containers/ClientCallbacksPage/ClientCallbacksSlice'
import additionalProductsTools from '@/containers/AdditionalSalesManagement/additionalProductsToolsSlice'
import searchContacts from '@/containers/ContactSearchPage/searchContactsSlice'
import contactsTools from '@/containers/DevToolsNew/Contacts/contactsSlice'
import podUpdaterTools from '@/containers/DevToolsNew/PodUpdater/podUpdaterSlice'
import commandsTools from '@/containers/DevToolsNew/Commands/commandsSlice'
import communicationBoardTools from '@/containers/DevToolsNew/CommunicationBoard/communicationBoardSlice'
import cacheTools from '@/containers/DevToolsNew/Cache/cacheSlice'
import feedbackTools from '@/containers/DevToolsNew/Feedback/feedbackSlice'
import nettingUpdaterTools from '@/containers/OrganizationsManagement/NettingUpdater/nettingUpdaterSlice'
import organizationsManagement from '@/containers/OrganizationsManagement/organizationsManagementSlice'
import dashboardV2 from '@/containers/DashboardPageV2/DashboardV2Slice'
import home from '@/containers/HomePage/HomeSlice'

const appReducer = combineReducers({
  auth,
  pageConfiguration,
  usersManagement,
  servicesStatus,
  carbonOffsets,
  officesManagement,
  teamsManagement,
  assistanceProducts,
  monConseillerPersoProducts,
  dashboard,
  subscriptionForm,
  subscriptionFormConfiguration,
  formV2,
  clientCallbacks,
  additionalProductsTools,
  contactsTools,
  podUpdaterTools,
  commandsTools,
  communicationBoardTools,
  cacheTools,
  feedbackTools,
  nettingUpdaterTools,
  organizationsManagement,
  searchContacts,
  dashboardV2,
  home,
})

export type RootState = ReturnType<typeof appReducer>

export const rootReducer = (state: ReturnType<typeof appReducer>, action: any) => appReducer(state, action)
